// ======================================================================
// File: crmDashboardMockData.js
// Purpose:
// Mock data for CRM Executive Dashboard
// ======================================================================

export const crmKpis = [
  {
    id: 1,
    title: "Total Enquiries",
    value: "1,248",
    trend: "+12%",
    trendType: "up",
    icon: "fas fa-envelope",
    color: "#2563eb",
    sparkline: [12,18,15,22,28,35]
  },
  {
    id: 2,
    title: "Open Enquiries",
    value: "186",
    trend: "+8%",
    trendType: "up",
    icon: "fas fa-bell",
    color: "#f59e0b",
    sparkline: [8,10,12,11,15,18]
  },
  {
    id: 3,
    title: "Active Quotations",
    value: "94",
    trend: "+15%",
    trendType: "up",
    icon: "fas fa-file-signature",
    color: "#7c3aed",
    sparkline: [5,7,8,10,12,14]
  },
  {
    id: 4,
    title: "Quotation Value",
    value: "₹4.82 Cr",
    trend: "+22%",
    trendType: "up",
    icon: "fas fa-coins",
    color: "#9333ea",
    sparkline: [10,15,18,22,28,34]
  },
  {
    id: 5,
    title: "Sales Orders",
    value: "62",
    trend: "+9%",
    trendType: "up",
    icon: "fas fa-shopping-cart",
    color: "#10b981",
    sparkline: [12,14,18,20,22,26]
  },
  {
    id: 6,
    title: "Order Value",
    value: "₹3.47 Cr",
    trend: "+18%",
    trendType: "up",
    icon: "fas fa-rupee-sign",
    color: "#059669",
    sparkline: [14,16,20,25,29,34]
  },
  {
    id: 7,
    title: "Conversion %",
    value: "67%",
    trend: "+4%",
    trendType: "up",
    icon: "fas fa-chart-line",
    color: "#dc2626",
    sparkline: [50,55,58,60,64,67]
  },
  {
    id: 8,
    title: "Top Customer",
    value: "L&T",
    trend: "₹8.4 Cr",
    trendType: "info",
    icon: "fas fa-building",
    color: "#0891b2",
    sparkline: [20,22,25,28,30,35]
  }
];

export const pipelineData = [
  {
    stage: "Enquiry",
    count: 1248,
  },
  {
    stage: "Quotation",
    count: 312,
  },
  {
    stage: "Negotiation",
    count: 148,
  },
  {
    stage: "Order",
    count: 62,
  },
];

export const enquiryTrend = [
  { month: "Jan", enquiries: 120 },
  { month: "Feb", enquiries: 145 },
  { month: "Mar", enquiries: 168 },
  { month: "Apr", enquiries: 190 },
  { month: "May", enquiries: 210 },
  { month: "Jun", enquiries: 235 },
];

export const revenueTrend = [
  { month: "Jan", revenue: 0.9 },
  { month: "Feb", revenue: 1.2 },
  { month: "Mar", revenue: 1.6 },
  { month: "Apr", revenue: 2.1 },
  { month: "May", revenue: 2.8 },
  { month: "Jun", revenue: 3.4 },
];

export const recentEnquiries = [
  {
    enquiry_no: "ENQ-1001",
    customer: "L&T",
    date: "2026-06-01",
    status: "Open",
  },
  {
    enquiry_no: "ENQ-1002",
    customer: "Tata Projects",
    date: "2026-06-02",
    status: "Follow-up",
  },
  {
    enquiry_no: "ENQ-1003",
    customer: "Adani",
    date: "2026-06-03",
    status: "Open",
  },
];

export const pendingQuotations = [
  {
    quotation_no: "QT-2001",
    customer: "L&T",
    value: "₹25 Lakhs",
    status: "Pending Approval",
  },
  {
    quotation_no: "QT-2002",
    customer: "Tata Projects",
    value: "₹42 Lakhs",
    status: "Negotiation",
  },
];

export const recentOrders = [
  {
    order_no: "SO-3001",
    customer: "L&T",
    value: "₹1.2 Cr",
  },
  {
    order_no: "SO-3002",
    customer: "Adani",
    value: "₹86 Lakhs",
  },
];

export const topCustomers = [
  {
    customer: "L&T",
    value: "₹8.4 Cr",
  },
  {
    customer: "Tata Projects",
    value: "₹5.8 Cr",
  },
  {
    customer: "Adani",
    value: "₹4.1 Cr",
  },
  {
    customer: "Shapoorji Pallonji",
    value: "₹3.7 Cr",
  },
];
export const crmActivities = [
  {
    title: "New enquiry received from L&T",
    time: "09:15 AM",
    color: "#2563eb",
  },
  {
    title: "Quotation QT-2001 approved",
    time: "10:20 AM",
    color: "#10b981",
  },
  {
    title: "Sales Order SO-3001 booked",
    time: "11:45 AM",
    color: "#7c3aed",
  },
  {
    title: "Customer follow-up completed",
    time: "01:15 PM",
    color: "#f59e0b",
  },
  {
    title: "Negotiation moved to Order stage",
    time: "02:30 PM",
    color: "#ef4444",
  },
];